const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import ModuleManager from "../../../../framework/core/module_manager";

@ccclass
export default class DialogReceiveMangoView extends ViewBase {

    @property([cc.Node])
    public readonly nodeList : cc.Node[] = [];


    onLoad(){        

       
    }

    onEnable(){


        this.hideContent();
    }

    // content [0,1,1]
    public updateContent( content : Number[]){
        
        
        content.forEach( (element,index) => {
            
            let node = this.nodeList[index];
            node.active = element != 0;                                
        });

    }

    public hideContent(){

        this.nodeList.forEach( (element,index) => {
            
            element.active = false;
        });
    }

}